export const SET_EVE_CLIENT_VERSION = 'BACKEND_VERSIONS_SET_EVE_CLIENT_VERSION'
export const SET_LAUNCHER_BACKEND_VERSION = 'BACKEND_VERSIONS_SET_LAUNCHER_BACKEND_VERSION'



// WEBPACK FOOTER //
// ./src/features/Backend/data/versions/constants.js